import React from 'react';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/', name: 'facebook'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/', name: 'linkedin'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/', name: 'instagram'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/', name: 'twitter'},
]

const FooterTwo = ({socialMedia}) => {
    
    return (
        <div className="footer-style-2 ptb--30 bg_image bg_image--1" data-black-overlay="6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner">
                            <div className="logo text-center text-sm-left mb_sm--20">
                                <a href="/">
                                    <img src="/assets/images/logo/whittyshield.png" width="60" alt="Digital Agency" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {socialMedia.map((val , i) => {
                                    const social = SocialShare.find( soc => { return soc.name === val.socialSite.toLowerCase()})
                                    return (
                                    <li key={i}><a href={`${val.url}`}>{social.Social}</a></li>
                                )})}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                            <div className="text">
                                <p>Copyright © 2020 Mercerworks, LLC. All Rights Reserved. Site built by <a href="https://www.berato.tech">Berato Wilson</a> using Rainbow Themes</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;